import { render, staticRenderFns } from "./CustomFatButton.vue?vue&type=template&id=6390bb41&scoped=true&"
import script from "./CustomFatButton.vue?vue&type=script&lang=js&"
export * from "./CustomFatButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomFatButton.vue?vue&type=style&index=0&id=6390bb41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390bb41",
  null
  
)

export default component.exports